import React from "react"
import Connect from "../base-pages/connect"

const ConnectCN = () => {
  return <Connect lang="cn" />
}

export default ConnectCN
